import { TemplateRef, Directive } from '@angular/core';

@Directive({
    selector: '[aaDashTabContent]',
    standalone: false
})
export class DashTabContentDirective
{
    constructor(public templateRef: TemplateRef<any>) { }
}
